import React from "react";
import ContributionContainer from "../containers/Contribution";

const Contribution = () => {
  return <ContributionContainer />;
};

export default Contribution;
